<template>
    <div>
      <listView :onLoad="metadata.loading" :showSideBar="false">
          <template slot="options-totalizer">
              <vs-row>Exibindo 0 de {{page_info.total}}</vs-row>
          </template>
        <template slot="container-header">
          <div class="relative mb-8">
            <!-- SEARCH INPUT -->
            <vs-input icon-pack="feather" class="w-full vs-input-shadow-drop vs-input-no-border d-theme-input-dark-bg" placeholder="Pesquisar" v-model="filters.searching" size="large" @input="getOrders"/>

            <!-- SEARCH ICON -->
            <div slot="submit-icon" class="absolute pin-t pin-r py-4 px-6">
              <feather-icon icon="SearchIcon" svgClasses="h-6 w-6" />
            </div>
          </div>
        </template>
          <template slot="container-body">
              <div class="h-full overflow-auto" @scroll.passive="paginator">
                  <vs-table :data="orders" noDataText="Não Há Vendas">
                      <template slot="thead">
                          <vs-th sort-key="order_code">#</vs-th>
                          <vs-th sort-key="customer_name">Cliente</vs-th>
                          <vs-th sort-key="valor">Valor</vs-th>
                          <vs-th sort-key="date">Data</vs-th>
                          <vs-th>Ações</vs-th>
                      </template>

                      <template slot-scope="{data}">
                          <vs-tr :key="indextr" v-for="(order, indextr) in data">
                              <vs-td :data="order.order_code">
                                {{ order.order_code }}
                              </vs-td>
                              <vs-td :data="order.customer_name">
                                {{ order.customer_name }}
                              </vs-td>
                              <vs-td :data="order.valor">
                                R$ {{ order.valor }}
                              </vs-td>
                              <vs-td :data="order.date">
                                  {{ order.date }}
                              </vs-td>
                              <vs-td>
                                <vs-button v-tooltip.top="`Visualizar venda`" type="flat" icon-pack="feather" icon="icon-shopping-bag" :to="`vendas/empresa/${order.customer_id}/codigo/${order.order_id}`"></vs-button>
                              </vs-td>
                          </vs-tr>
                      </template>
                  </vs-table>
            </div>
          </template>
      </listView>
    </div>
</template>

<script>

import moment from 'moment';

export default {
    components: {
        listView: () => import("../components/list-view/list-view")
    },
    data() {
        return {
          orders: [],
          metadata: {
            loading: false
          },
          filters: {
            searching: ''
          },
          page_info: {
              nextUrl: null,
              lastIndex: null,
              currentIndex: null,
              total: 0
          }
        }
    },

    methods: {
        getOrders: _.debounce(async function () {
            this.metadata.loading = true;
            const {data} = await this.$axios('store/orders', {params: {
              q:this.filters.searching
            }});
            this.merginData(data.data, true);
            this.page_info.nextUrl = data.next_page_url;
            this.page_info.lastIndex = data.last_page;
            this.page_info.currentIndex = data.current_page;
            this.page_info.total = data.total;
            this.metadata.loading = false;
        }, 350),

        merginData(orders, reset = false) {
              const newOrders = orders.map(order => ({
                  order_id: order.id_movimento, order_code: order.codigo_movimento, customer_name: order.pessoa_nome, customer_id: order.id_pessoa,
                  date: moment(order.data_hora_venda).format('DD-MM-YYYY'), valor: this.currency(order.valor)
                }));
              if (reset) {
                this.orders = newOrders;
              } else {
                this.orders = [...this.orders, ...newOrders];
              }
        },

        currency (money) {
              money = parseFloat(money).toFixed(2).split('.');
              money[0] = money[0].split(/(?=(?:...)*$)/).join('.');
              return money.join(',');
        },
        paginator: _.debounce(async function ({target}) {
            if ((target.scrollHeight - target.offsetHeight) - target.scrollTop <= 2) {
                if (this.page_info.currentIndex < this.page_info.lastIndex) {
                    this.metadata.loading = true;
                    const {data} = await this.$axios.get(this.page_info.nextUrl, {params:{q:this.filters.searching}});
                    this.page_info.currentIndex = data.current_page;
                    this.page_info.nextUrl = data.next_page_url;
                    this.merginData(data.data);
                    this.metadata.loading = false;
                }
            }
           }, 1000)
    },

    created () {
        this.getOrders();
    }
}
</script>
